<template>
  <section class="terms-page">
    <div class="container">
      <div class="row align-items-center justify-content-center">
        <div
            class="col-12 col-md-8 col-lg-6 col-xl-5 intro-section__headline">
          <form @submit.prevent="updateUser">
            <div class="text-center">
              <h3 class="title">{{ $t('forms.signup_form.privacy_conditions_title') }}</h3>
            </div>
            <div class="form-check-container text-left">
              <div class="" v-if="$store.state.appConfig.appConfigReady">
                <div
                    v-if="$store.state.appConfig.privacyCheckboxes && $store.getters['appConfig/getPrivacyCheckboxes'].length">
                  <template v-for="checkbox in $store.getters['appConfig/getPrivacyCheckboxes']">
                    <b-form-checkbox v-model="userCheckboxChoices[checkbox.field_name]" :required="checkbox.is_required"
                                     :name="checkbox.field_name"
                                     :value="true"
                                     :key="checkbox.field_name"
                                     :unchecked-value="false">

                      <span v-html="checkbox.label"></span>
                    </b-form-checkbox>
                  </template>
                </div>
                <div v-else>
                  <div class="form-group">
                    <b-form-checkbox v-model="consent_privacy_and_terms" required
                                     name="consent_privacy_and_terms"
                                     value="true"
                                     unchecked-value="false">
                      <template>
                        <span v-html="privacyStatement"></span>
                      </template>
                    </b-form-checkbox>
                  </div>
                  <div class="form-group" v-if="!isAnonymous">
                    <b-form-checkbox v-model="consent3rdPartyMarketing"
                                     name="consent_3rd_party_marketing"
                                     value="true"
                                     unchecked-value="false">
                      <template>
                        {{ $t('modal_marketing_consent.txt') }}
                      </template>
                    </b-form-checkbox>
                  </div>
                </div>
                <span class="form-group--error__message" v-if="hasValidationError('consent_privacy_and_terms')">
                  {{ validationErrors.consent_privacy_and_terms }}
                </span>
              </div>
            </div>

            <div class="form-group">
              <div class="row w-100 justify-content-center">
                <div class="col-sm-6 order-sm-1 mb-2 mb-sm-0">
                  <b-button variant="primary" block type="submit" :disabled="loading">
                    <b-spinner small label="Loading..." v-if="loading"></b-spinner>
                    <span v-else>{{ $t('forms.signup_form.btn_continue') }}</span>
                  </b-button>
                </div>
                <div class="col-sm-6 order-sm-0">
                  <b-button variant="light" block @click="logout">
                    {{ $t('forms.signup_form.btn_back') }}
                  </b-button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

  </section>
</template>


<script>
import {mapGetters} from "vuex";
import UserService from "@/services/User";
import {policyUrl} from "@/utils";

export default {
  name: 'TermsPage',
  metaInfo: {
    title: 'Terms and conditions'
  },

  components: {},

  data() {
    return {
      loading: false,
      consent_privacy_and_terms: false,
      consent3rdPartyMarketing: false,
      validationErrors: {},
      userCheckboxChoices: {}
    }
  },

  watch: {
    getAppConfigReady: {
      handler: async function (value) {
        if (value) {
          this.setUserCheckboxChoices()
        }
      },
      immediate: true
    },
  },
  computed: {
    ...mapGetters('auth', ['isAnonymous']),
    ...mapGetters('appConfig', [
      'getPrivacyCheckboxes', 'getAppConfigReady'
    ]),
    privacyStatement() {
      return this.$t('forms.signup_form.privacy_statement', {
        terms_url: this.policyUrl().terms,
        privacy_url: this.policyUrl().privacy
      })
    }
  },

  methods: {
    policyUrl,
    async updateUser() {
      this.validationErrors = Object.assign({}, this.validationErrors, {})
      this.loading = true

      let payload = {}
      if (this.$store.state.appConfig.eventOwnerId && this.$store.getters['appConfig/getPrivacyCheckboxes'].length) {
        Object.assign(payload, {
          "consent_third_party_fields": this.userCheckboxChoices
        })
      } else {
        Object.assign(payload, {
          'consent_privacy_and_terms': this.consent_privacy_and_terms,
          'consent_3rd_party_marketing': this.consent3rdPartyMarketing
        })
      }

      try {
        await UserService.updateUser(payload)
      } catch (error) {
        this.validationErrors = Object.assign({}, this.validationErrors, error.response.data)
      } finally {
        this.loading = false
      }
      await this.$store.dispatch('auth/getCurrentUser')
      let next = this.$route.params.next;
      await this.$router.push({name: next || "checkins-list"})
    },

    hasValidationError(fieldName) {
      return this.validationErrors.hasOwnProperty(fieldName)
    },

    setUserCheckboxChoices() {
      let defaultModel = {}
      const checkboxes = this.$store.getters['appConfig/getPrivacyCheckboxes']
      checkboxes.forEach(function (checkbox) {
        defaultModel[checkbox.field_name] = false
      });
      this.$set(this, "userCheckboxChoices", defaultModel)
    },

    logout() {
      this.$store.dispatch('auth/logout').then(() => this.$router.push('/'))
    }
  }
}
</script>
